import { Controller } from '@hotwired/stimulus'

// Click-to-copy: clicking anywhere on the element copies `text-value` to the
// clipboard and briefly flashes the "Copied!" confirmation target.
export default class extends Controller {
  static values = { text: String }
  static targets = ['confirmation']

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => this.flash())
  }

  flash() {
    this.confirmationTarget.classList.remove('opacity-0')
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.confirmationTarget.classList.add('opacity-0')
    }, 1500)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
